import { useState, useEffect } from 'react';

export const useAdBlockDetector = () => {
  const [isAdBlockActive, setIsAdBlockActive] = useState(false);

  useEffect(() => {
    const checkAdBlock = async () => {
      try {
        // ลองยิง Request ไปที่ URL ของ Google Ads ที่ AdBlock ทุกตัวตั้งค่าให้บล็อกเสมอ
        await fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
          method: 'HEAD',
          mode: 'no-cors',
          cache: 'no-store',
        });
        setIsAdBlockActive(false); // โหลดได้ = ไม่มี AdBlock
      } catch (error) {
        setIsAdBlockActive(true); // โหลดไม่ได้ (โดนตัด Connection) = มี AdBlock
      }
    };

    checkAdBlock();
  }, []);

  return isAdBlockActive;
};